import { Link } from 'react-router-dom';
import { Controller } from 'react-hook-form';
import { Breadcrumb, Button, Col, Divider, Form, Input, Row } from 'antd';
import Title from 'antd/es/typography/Title';
import { BarsOutlined } from '@ant-design/icons';

import { colInputs } from './GridStyle';
import { ISubjectContact } from '../../../HelpAndSupport/interfaces';
import useSubjectForm from './useSubjectForm';

interface IProps {
    action: 'Adicionar' | 'Editar';
    subject?: ISubjectContact;
    onSubmit: (data: FormData) => Promise<void>;
}

export default function SubjectForm({ action, subject, onSubmit }: IProps) {
    const {
        handleSubmitForm,
        handleSubmit,
        isSubmiting,
        errors,
        control,
    } = useSubjectForm(onSubmit, subject);

    return (
        <>
            <Row>
                <Col>
                    <Title level={3}><BarsOutlined style={{ fontSize: 35, marginRight: 10 }} /> {action} Assunto</Title>
                    <Breadcrumb
                        items={[
                            {
                                title: <Link to='/configuracoes/assuntos-ajuda-e-suporte'>Assuntos</Link>,
                            },
                            {
                                title: `${action} Assunto`,
                            }
                        ]}
                    />
                    <Divider />
                </Col>
            </Row>
            <Form
                onFinish={handleSubmit(handleSubmitForm)}
                autoComplete='off'
                layout='vertical'
            >
                <Row
                    gutter={16}
                >
                    <Col
                        {...colInputs}
                    >
                        <Form.Item
                            label="Nome"
                            required
                            validateStatus={errors.name ? 'error' : 'success'}
                            help={errors.name?.message}
                        >
                            <Controller
                                name="name"
                                control={control}
                                rules={{ required: { value: true, message: 'Por favor, digite o nome do Tipo de Prêmio!' }, }}
                                render={({ field }) => <Input {...field} placeholder='Nome' />}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Button
                    type='primary'
                    htmlType='submit'
                    disabled={isSubmiting}
                    loading={isSubmiting}
                >
                    Salvar
                </Button>
            </Form>
        </>

    )
}
